import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  sendLogToAPI({ state }, data = {}) {
    return axios.post(
      `${appConfig.apiEndPoint}${endpoint.adminApiPath.sendLog}`,
      data,
      {
        headers: setHeaders(),
      }
    )
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
